/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Rail_Plans_BodyInputs */

const en_platform_rail_plans_body = /** @type {(inputs: Platform_Rail_Plans_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weeks, days and exercises from your library, with sets and load.`)
};

const pl_platform_rail_plans_body = /** @type {(inputs: Platform_Rail_Plans_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tygodnie, dni i ćwiczenia z Twojej biblioteki, z seriami i ciężarem.`)
};

/**
* | output |
* | --- |
* | "Weeks, days and exercises from your library, with sets and load." |
*
* @param {Platform_Rail_Plans_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_rail_plans_body = /** @type {((inputs?: Platform_Rail_Plans_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Rail_Plans_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_rail_plans_body(inputs)
	return en_platform_rail_plans_body(inputs)
});